const namespace = 'DIALOGS';
export const ON_DIALOG_OPEN_CHANGED = namespace + "@ON_DIALOG_OPEN_CHANGED";